import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import PresentationAttributeApi from '@/api/presentation-attribute'
import constant from '@/constant'

const SYSTEM_FIELDS = 'systemField'
const participantSystemField = [
  {
    name: 'name',
    type: 'name',
    fieldType: SYSTEM_FIELDS,
    label: 'Enter your name:',
    required: false,
    id: 1,
  },
  {
    name: 'email',
    type: 'email',
    fieldType: SYSTEM_FIELDS,
    label: 'Enter your email address:',
    required: false,
    id: 3,
  },
  {
    name: 'avatar',
    type: 'avatar',
    fieldType: SYSTEM_FIELDS,
    label: 'Choose an emoji as your avatar:',
    required: false,
    id: 11,
  },
]

const _state = {
  presentationAttribute: {},
}

const mutations = {
  setPresentationAttribute(state, payload) {
    state.presentationAttribute = payload
  },
  updatePresentationAttribute(state, payload) {
    Vue.set(state.presentationAttribute, payload.attributeName, payload.attributeValue)
  },
}

const actions = {
  async getPresentationAttributeAction({ commit }, presentationId) {
    try {
      const resp = await PresentationAttributeApi.getPresentationAttributes(presentationId)
      commit('setPresentationAttribute', resp.body)
      return resp.body
    } catch (error) {
      Sentry.captureMessage(new Error('Get Presentation Attribute Error'), {
        level: 'warning',
        extra: {
          presentationId,
          error,
        },
      })
      return {}
    }
  },
}

const _getters = {
  presentationColorPalette: (state, _, __, rootGetters) => {
    if (state.presentationAttribute?.colorPalette?.colors) {
      return state.presentationAttribute.colorPalette.colors
    }
    if (rootGetters['featureToggles/canUseNewColors']) {
      return constant.colors2025
    }
    return constant.colors
  },
  presentationLighterColorPalette: (state, _, __, rootGetters) => {
    if (state.presentationAttribute?.colorPalette?.lighterColors) {
      return state.presentationAttribute.colorPalette.lighterColors
    }
    if (rootGetters['featureToggles/canUseNewColors']) {
      return constant.lighterColors2025
    }
    return constant.lighterColors
  },

  presentationAttributeColorPalette: (state) => {
    return state.presentationAttribute.colorPalette || {}
  },
  presentationParticipantFields: (state) => {
    return [
      ...participantSystemField,
      ...(state.presentationAttribute?.participantFields?.fields || []),
    ]
  },
}

export default {
  namespaced: true,
  state: _state,
  mutations,
  actions,
  getters: _getters,
}
